import React, { useState, useEffect } from 'react';
import classes from './signedDocuments.module.css';
import { sixYardAxios } from '../../../sixYardAxios';
import Button from '../../containers/button/button';
import Pencil from '../../../assets/images/Pencil.png';
import PromptMessage from '../../containers/promptMessage/promptMessage';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SignedDocuments = (props) => {
    const userAgent = navigator.userAgent;
    const [documents, setDocuments] = useState([]);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [enableInput, setEnableInput] = useState(false);
    const [showPromptMessage, setShowPromptMessage] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [email, setEmail] = useState("");
    const [kids, setKids] = useState([]);
    const [signature, setSignature] = useState("");
    const [referenceSource, setReferenceSource] = useState("");
    const [referenceDetails, setReferenceDetails] = useState("");

    const isEnglish = parseInt(localStorage.getItem('language')) === 1;

    const translations = {
        declaration: {
            en: 'Declaration By The Guardian',
            ar: 'إقرار من الوصي'
        },
        academy: {
            en: 'Academy Form',
            ar: 'Academy نموذج'
        },
        camp: {
            en: 'Camp Form',
            ar: 'Camp نموذج'
        },
        toBeSignedBy: {
            en: 'To be signed by the Guardians',
            ar: 'يجب أن يوقع من قبل الأوصياء'
        },
        i: {
            en: 'I,',
            ar: 'أنا،'
        },
        ofAddress: {
            en: 'of address',
            ar: 'العنوان'
        },
        andEmail: {
            en: 'and email',
            ar: 'والبريد الإلكتروني'
        },
        responsibility: {
            en: 'being a person having parental responsibility for',
            ar: 'بصفتي الشخص المسؤول عن'
        },
        and: {
            en: 'and',
            ar: 'و'
        },
        certifyText: {
            en: ', and certify that the above details are correct and that in consideration of 6 Yard\'s acceptance of the Entrant\'s entry into the 6 Yard, the receipt and sufficiency of which consideration is acknowledged, hereby release and forever discharge 6 Yard, its owners, directors, officers, employees, agents, assigns, legal representatives, and successors from all manner of actions, causes of action, debts, accounts, bonds, contracts, claims, and demands for or by reason of any injury to the Entrant which has been or may be sustained as a consequence of an incident occurring at the 6 Yard or arising from the Entrant\'s participation in the 6 Yard.',
            ar: '، وأشهد أن التفاصيل المذكورة أعلاه صحيحة وأنه في ضوء قبول 6 Yard لدخول المشارك إلى 6 Yard، والذي تم استلام واعتبار كفايته، أعفي وأبرئ ذمة 6 Yard ومالكيها ومديريها ومسؤوليها وموظفيها ووكلائها والمعينين والممثلين القانونيين والخلفاء من جميع أنواع الإجراءات وأسباب الإجراءات والديون والحسابات والسندات والعقود والمطالبات والمطالب بسبب أي إصابة للمشارك التي حدثت أو قد تحدث نتيجة حادث وقع في 6 Yard أو ناشئ عن مشاركة المشارك في 6 Yard.'
        },
        waiverText: {
            en: 'I hereby further declare that the terms of this waiver are fully understood; that the amount or type of consideration stated consideration is accepted voluntarily for the purpose of making a full and final compromise and settlement of all claims for injuries, losses, and damages which may result from the aforementioned incident or the Entrant\'s participation in the 6 Yard.',
            ar: 'أقر بموجب هذا أن شروط هذا التنازل مفهومة تماماً؛ وأن مقدار أو نوع المقابل المذكور مقبول طواعية لغرض إجراء تسوية كاملة ونهائية لجميع المطالبات عن الإصابات والخسائر والأضرار التي قد تنتج عن الحادث المذكور أو مشاركة المشارك في 6 Yard.'
        },
        signBelow: {
            en: 'Please sign in the field below',
            ar: 'يرجى التوقيع في الحقل أدناه'
        },
        enterName: {
            en: 'Enter your name',
            ar: 'أدخل اسمك'
        },
        enterAddress: {
            en: 'Enter your address',
            ar: 'أدخل عنوانك'
        },
        enterEmail: {
            en: 'Enter your email',
            ar: 'أدخل بريدك الإلكتروني'
        },
        firstKid: {
            en: 'First kid name',
            ar: 'اسم الطفل الأول'
        },
        secondKid: {
            en: 'Second kid name',
            ar: 'اسم الطفل الثاني'
        },
        signature: {
            en: 'Signature',
            ar: 'التوقيع'
        },
        referenceSource: {
            en: 'Reference Source',
            ar: 'مصدر المرجع'
        },
        referenceDetails: {
            en: 'Reference Details',
            ar: 'تفاصيل المرجع'
        },
        selectSource: {
            en: 'Select source',
            ar: 'اختر المصدر'
        },
        enterDetails: {
            en: 'Enter reference details',
            ar: 'أدخل تفاصيل المرجع'
        },
        cancel: {
            en: 'CANCEL',
            ar: 'إلغاء'
        },
        save: {
            en: 'SAVE',
            ar: 'حفظ'
        }
    };

    useEffect(() => {
        fetchDocuments();
    }, []);

    const fetchDocuments = async () => {
        try {
            const response = await sixYardAxios.get('/documents');
            setDocuments(response.data.data);
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to fetch documents');
        }
    };

    const handleEditDocument = (document) => {
        setSelectedDocument(document);
        setName(document.guardian_name);
        setAddress(document.guardian_address);
        setEmail(document.guardian_email);
        setKids(document.kids || []);
        setSignature(document.signature);
        setReferenceSource(document.reference_source || "");
        setReferenceDetails(document.reference_details || "");
        setEnableInput(true);
    };

    const handleKidChange = (index, value) => {
        const updatedKids = [...kids];

        if (value === "" || value === null) {
            updatedKids.splice(index, 1);
        } else {
            updatedKids[index] = value;
        }

        setKids(updatedKids.filter((kid) => kid));
    };

    const submitHandler = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        const getIpAddress = await fetch('https://api.ipify.org?format=json').then(response => response.json());
        
        try {
            const formData = {
                guardian_name: name,
                guardian_address: address,
                guardian_email: email,
                kids: kids,
                signature: signature,
                reference_source: referenceSource,
                reference_details: referenceDetails,
                ip_address: getIpAddress.ip,
                user_agent: userAgent,
            };

            if (selectedDocument) {
                formData.id = selectedDocument.id;
                formData.type = selectedDocument.type;
                formData.registration_id = selectedDocument.registration_id;
            }

            const response = await sixYardAxios.post('/documents', formData);
            
            if (response.data.data) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setShowPromptMessage(response.data.data.message || 'Updated successfully');
                setEnableInput(false);
                setSelectedDocument(null);
                fetchDocuments();
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: '0',
        cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
        autoplay: false,
        rtl: !isEnglish,
        customPaging: function(i) {
            return <div className={classes.customDot} />;
        },
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '0',
                    arrows: true
                }
            }
        ]
    };

    const renderDocumentsList = () => {
        if (!documents.length) {
            return null;
        }

        return (
            <div className={classes.sliderContainer} dir={isEnglish ? 'ltr' : 'rtl'}>
                <Slider {...sliderSettings}>
                    {documents.map((doc) => (
                        <div key={doc.id}>
                            <div className={`${classes.declarationContainer} ${!isEnglish ? classes.rtl : ''}`}>
                                <div className={classes.documentTypeTitle}>
                                    {doc.type === 'academy' ? 'Academy Form' : 'Camp Form'}
                                </div>
                                <div className={classes.textDeclarationTitle}>
                                    {isEnglish ? translations.declaration.en : translations.declaration.ar}
                                </div>
                                
                                <div className={classes.PencilContainer} onClick={() => handleEditDocument(doc)}>
                                    <img src={Pencil} alt='pencil' />
                                </div>
                                
                                <div className={classes.signatureSection}>
                                    <span>{isEnglish ? translations.toBeSignedBy.en : translations.toBeSignedBy.ar}</span>
                                    <div className={classes.redDot}>*</div>
                                </div>

                                <div className={classes.iText}>
                                    {isEnglish ? translations.i.en : translations.i.ar}
                                    <div className={classes.inputLine}>
                                        <span>{doc.guardian_name}</span>
                                    </div>
                                </div>

                                <div className={classes.inputGroup}>
                                    <span>{isEnglish ? translations.ofAddress.en : translations.ofAddress.ar}</span>
                                    <div className={classes.inputLine}>
                                        <span>{doc.guardian_address}</span>
                                    </div>
                                </div>

                                <div className={classes.inputGroup}>
                                    <span>{isEnglish ? translations.andEmail.en : translations.andEmail.ar}</span>
                                    <div className={classes.inputLine}>
                                        <span>{doc.guardian_email}</span>
                                    </div>
                                </div>

                                <div className={classes.responsibilityText}>
                                    {isEnglish ? translations.responsibility.en : translations.responsibility.ar}
                                </div>

                                {doc.kids && doc.kids.map((kid, index) => (
                                    <React.Fragment key={index}>
                                        <div className={classes.inputLine}>
                                            <span>{kid}</span>
                                        </div>
                                        {index < doc.kids.length - 1 && (
                                            <div className={classes.andText}>{isEnglish ? translations.and.en : translations.and.ar}</div>
                                        )}
                                    </React.Fragment>
                                ))}

                                <div className={classes.certifyText}>
                                    {isEnglish ? translations.certifyText.en : translations.certifyText.ar}
                                </div>

                                <div className={classes.waiverText}>
                                    {isEnglish ? translations.waiverText.en : translations.waiverText.ar}
                                </div>

                                <div className={classes.inputGroup}>
                                    <span>{isEnglish ? translations.referenceSource.en : translations.referenceSource.ar}</span>
                                    <div className={classes.inputLine}>
                                        <span>{doc.reference_source}</span>
                                    </div>
                                </div>

                                <div className={classes.inputGroup}>
                                    <span>{isEnglish ? translations.referenceDetails.en : translations.referenceDetails.ar}</span>
                                    <div className={classes.inputLine}>
                                        <span>{doc.reference_details}</span>
                                    </div>
                                </div>

                                <div className={classes.signBelowText}>{isEnglish ? translations.signBelow.en : translations.signBelow.ar}</div>

                                <div className={classes.inputSignature}>
                                    <div className={classes.signatureName}>{doc.signature}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>
            </div>
        );
    };

    return (
        <div className={classes.Container}>
            {!enableInput && renderDocumentsList()}

            {enableInput && (
                <form className={classes.declarationContainer} onSubmit={(e) => submitHandler(e)}>
                    <div className={classes.textDeclarationTitle}>
                        {isEnglish ? translations.declaration.en : translations.declaration.ar}
                    </div>

                    <div className={classes.Buttons}>
                        <Button 
                            content={isEnglish ? translations.cancel.en : translations.cancel.ar}
                            whiteBackground 
                            onClick={() => {
                                setEnableInput(false);
                                setSelectedDocument(null);
                            }} 
                        />
                        <Button 
                            content={isEnglish ? translations.save.en : translations.save.ar}
                            type="submit"
                        />
                    </div>

                    <div className={classes.signatureSection}>
                        <span>{isEnglish ? translations.toBeSignedBy.en : translations.toBeSignedBy.ar}</span>
                        <div className={classes.redDot}>*</div>
                    </div>

                    <div className={classes.iText}>
                        {isEnglish ? translations.i.en : translations.i.ar}
                        <div className={classes.inputLine}>
                            <input 
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                placeholder={isEnglish ? translations.enterName.en : translations.enterName.ar}
                                className={enableInput && classes.EnableInput}
                            />
                            <div className={classes.redDot}>*</div>
                        </div>
                    </div>

                    <div className={classes.inputGroup}>
                        <span>{isEnglish ? translations.ofAddress.en : translations.ofAddress.ar}</span>
                        <div className={classes.inputLine}>
                            <input 
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                                placeholder={isEnglish ? translations.enterAddress.en : translations.enterAddress.ar}
                                className={enableInput && classes.EnableInput}
                            />
                            <div className={classes.redDot}>*</div>
                        </div>
                    </div>

                    <div className={classes.inputGroup}>
                        <span>{isEnglish ? translations.andEmail.en : translations.andEmail.ar}</span>
                        <div className={classes.inputLine}>
                            <input 
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder={isEnglish ? translations.enterEmail.en : translations.enterEmail.ar}
                                className={enableInput && classes.EnableInput}
                            />
                            <div className={classes.redDot}>*</div>
                        </div>
                    </div>

                    <div className={classes.responsibilityText}>
                        {isEnglish ? translations.responsibility.en : translations.responsibility.ar}
                    </div>

                    <div className={classes.inputLine}>
                        <input
                            value={kids[0] || ''}
                            onChange={(e) => handleKidChange(0, e.target.value)}
                            placeholder={isEnglish ? translations.firstKid.en : translations.firstKid.ar}
                            className={enableInput && classes.EnableInput}
                        />
                        <div className={classes.redDot}>*</div>
                    </div>

                    <div className={classes.andText}>
                        {isEnglish ? translations.and.en : translations.and.ar}
                    </div>

                    <div className={classes.inputLine}>
                        <input
                            value={kids[1] || ''}
                            onChange={(e) => handleKidChange(1, e.target.value)}
                            placeholder={isEnglish ? translations.secondKid.en : translations.secondKid.ar}
                            className={enableInput && classes.EnableInput}
                        />
                    </div>

                    <div className={classes.certifyText}>
                        {isEnglish ? translations.certifyText.en : translations.certifyText.ar}
                    </div>

                    <div className={classes.waiverText}>
                        {isEnglish ? translations.waiverText.en : translations.waiverText.ar}
                    </div>

                    <div className={classes.inputGroup}>
                        <span>{isEnglish ? translations.referenceSource.en : translations.referenceSource.ar}</span>
                        <div className={classes.inputLine}>
                            <div className={classes.selectContainer}>
                                <select
                                    value={referenceSource}
                                    onChange={(e) => setReferenceSource(e.target.value)}
                                    className={enableInput && classes.EnableInput}
                                    required
                                >
                                    <option value="" disabled>{isEnglish ? translations.selectSource.en : translations.selectSource.ar}</option>
                                    <option value="instagram">Instagram</option>
                                    <option value="facebook">Facebook</option>
                                    <option value="other">{isEnglish ? 'Other' : 'أخرى'}</option>
                                </select>
                                <div className={classes.selectArrow}></div>
                            </div>
                            <div className={classes.redDot}>*</div>
                        </div>
                    </div>

                    <div className={classes.inputGroup}>
                        <span>{isEnglish ? translations.referenceDetails.en : translations.referenceDetails.ar}</span>
                        <div className={classes.inputLine}>
                            <input
                                value={referenceDetails}
                                onChange={(e) => setReferenceDetails(e.target.value)}
                                placeholder={isEnglish ? translations.enterDetails.en : translations.enterDetails.ar}
                                className={enableInput && classes.EnableInput}
                                required
                            />
                            <div className={classes.redDot}>*</div>
                        </div>
                    </div>

                    <div className={classes.signBelowText}>{isEnglish ? translations.signBelow.en : translations.signBelow.ar}</div>

                    <div className={classes.inputSignature}>
                        <input
                            value={signature}
                            onChange={(e) => setSignature(e.target.value)}
                            placeholder={isEnglish ? translations.signature.en : translations.signature.ar}
                            className={[classes.signatureName, enableInput && classes.EnableInput].join(" ")}
                        />
                        <div className={classes.redDot}>*</div>
                    </div>
                </form>
            )}

            {showPromptMessage && (
                <PromptMessage 
                    status='CONGRATULATIONS' 
                    message={showPromptMessage}
                    button='CLOSE' 
                    click={() => setShowPromptMessage(false)} 
                    successMessage 
                />
            )}
            
            {error && (
                <PromptMessage 
                    message={error} 
                    status='Oops' 
                    button='CLOSE' 
                    click={() => setError(false)} 
                />
            )}
        </div>
    );
}

export default SignedDocuments;